import { Area } from 'os/shared/utils/src/types/Area';
import { Size } from 'ff-canvas';

export const calculateZoom = (cropBox: Area, imageSize: Size, mode: 'contain' | 'cover') => {

    const widthRatio = imageSize.width / cropBox.width;
    const heightRatio = imageSize.height / cropBox.height;

    return mode === 'contain'
        ? Math.max(widthRatio, heightRatio)
        : Math.min(widthRatio, heightRatio);
};